module.exports = __webpack_public_path__ + "static/media/scene_creator_onboarding_3.2b0993d2.jpg";